import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';

import { loginReducer } from './redux/reducers/authReducers';
import { createSalesOrderReducer, deleteSalesOrderReducer, getSalesOrderReducer, getCustomerSalesOrderReducer, updateSalesOrderReducer, generatePdfReducer } from './redux/reducers/salesOrderReducers';
import { createCustomerInvoiceReducer, deleteCustomerInvoiceReducer, getCustomerInvoiceReducer, updateCustomerInvoiceReducer, getPenaltiesReducer } from './redux/reducers/customerInvoiceReducers';
import { createReceivableReducer, deleteReceivableReducer, getReceivableReducer, updateReceivableReducer } from './redux/reducers/receivableReducers';
import { createBranchReducer, deleteBranchReducer, getBranchReducer, updateBranchReducer } from './redux/reducers/branchMasterReducers'
import { createExpenseReducer, deleteExpenseReducer, getExpenseReducer, updateExpenseReducer } from './redux/reducers/expenseMasterReducers';
import { createVendorReducer, deleteVendorReducer, getVendorReducer, updateVendorReducer } from './redux/reducers/vendorMasterReducers';
import { approveBillsReducer, approvePaymentsReducer, rejectBillsReducer, rejectPaymentsReducer } from './redux/reducers/approvalReducers';
import { createBillingPartyReducer, deleteBillingPartyReducer, getBillingPartyReducer, updateBillingPartyReducer, getBillingPartyBranchReducer } from './redux/reducers/billingPartyReducers';
import { getConsigneeReducer, createConsigneeReducer, updateConsigneeReducer, deleteConsigneeReducer } from './redux/reducers/consigneeMasterReducers';
import { createConsignorReducer, deleteConsignorReducer, getConsignorReducer, updateConsignorReducer } from './redux/reducers/consignorMasterReducers';
import { getTargetReducer } from './redux/reducers/targetMasterReducers';

const reducer = combineReducers({
    loginData: loginReducer,

    getSalesOrderData: getSalesOrderReducer,
    createSalesOrderData: createSalesOrderReducer,
    updateSalesOrderData: updateSalesOrderReducer,
    deleteSalesOrderData: deleteSalesOrderReducer,
    getCustomerSalesOrderData: getCustomerSalesOrderReducer,
    generatePdfData: generatePdfReducer,

    getCustomerInvoiceData: getCustomerInvoiceReducer,
    createCustomerInvoiceData: createCustomerInvoiceReducer,
    updateCustomerInvoiceData: updateCustomerInvoiceReducer,
    deleteCustomerInvoiceData: deleteCustomerInvoiceReducer,
    getPenaltiesData: getPenaltiesReducer,

    getReceivableData: getReceivableReducer,
    createReceivableData: createReceivableReducer,
    updateReceivableData: updateReceivableReducer,
    deleteReceivableData: deleteReceivableReducer,

    getBranchData: getBranchReducer,
    createBranchData: createBranchReducer,
    updateBranchData: updateBranchReducer,
    deleteBranchData: deleteBranchReducer,

    getExpenseData: getExpenseReducer,
    createExpenseData: createExpenseReducer,
    updateExpenseData: updateExpenseReducer,
    deleteExpenseData: deleteExpenseReducer,

    getVendorData: getVendorReducer,
    createVendorData: createVendorReducer,
    updateVendorData: updateVendorReducer,
    deleteVendorData: deleteVendorReducer,

    approveBillsData: approveBillsReducer,
    rejectBillsData: rejectBillsReducer,
    approvePaymentsData: approvePaymentsReducer,
    rejectPaymentsData: rejectPaymentsReducer,

    getBillingPartyData: getBillingPartyReducer,
    createBillingPartyData: createBillingPartyReducer,
    updateBillingPartyData: updateBillingPartyReducer,
    deleteBillingPartyData: deleteBillingPartyReducer,

    getBillingPartyBranchData: getBillingPartyBranchReducer,

    getConsigneeData: getConsigneeReducer,
    createConsigneeData: createConsigneeReducer,
    updateConsigneeData: updateConsigneeReducer,
    deleteConsigneeData: deleteConsigneeReducer,

    getConsignorData: getConsignorReducer,
    createConsignorData: createConsignorReducer,
    updateConsignorData: updateConsignorReducer,
    deleteConsignorData: deleteConsignorReducer,
    getTargetData: getTargetReducer,

})

const middleware = [thunk];
const initialState = {};

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    reducer,
    initialState,
    composeEnhancer(applyMiddleware(...middleware))
)

export default store;